module.exports = __webpack_public_path__ + "img/cinema.d2bbaf7c.jpg";